<template>
    <div class="fcsd-yc-page">
        <div class="tit">
            <span>1.填写标题</span>
            <span>温馨提示：每个指标都必须预测。</span>
        </div>
        <div class="qihao">
            [{{ vuex_userInfo.userName }}]福彩3D第{{ form.number }}期缩水师预测
            <input type="text" v-model="form.title">
        </div>
        <div class="notice">发缩水单在开奖当天18:00点截止，重新上传或者编辑到我的专栏</div>
        <div class="tit">
            <span>2.预测列表</span>
            <span>温馨提示：每个指标都需要预测</span>
            <div class="links">
                <span style="cursor: pointer;" @click="$router.push('/article_details?id=29&type=help')">收费标准</span>
                <span style="cursor: pointer;" @click="$router.push('/article_details?id=53&type=help')">积分规则</span>
                <span style="cursor: pointer;" @click="$router.push('/article_details?id=47&type=help')">阶梯提成</span>
            </div>
        </div>
        <el-dialog title="软件格式" :visible.sync="showImgDialog" width="60%" center>
            <div class="format-img-box">
                <img class="format-img" src="@/assets/imglog/3d.png" />
            </div>
        </el-dialog>

        <div class="table-wrap">
            <div class="list">
                <div class="row head">
                    <span>预测指标</span> <span>操作</span>
                </div>
                <div class="row"> <span>800-899注</span> <span> <input type="file" data-type="5"
                        data-fileType="pre_index_fucai3d_eight_h" accept=".txt" @change="chooseFile"></span> </div>
                <div class="row"> <span>700-799注</span> <span> <input type="file" data-type="0"
                        data-fileType="pre_index_fucai3d_seven_h" accept=".txt" @change="chooseFile"></span> </div>
                <div class="row"> <span>400-599注</span> <span> <input type="file" data-type="1" data-fileType="pre_index_fucai3d_four_h"
                        accept=".txt" @change="chooseFile"></span> </div>
                <div class="row"> <span>200-399注</span> <span> <input type="file" data-type="2" data-fileType="pre_index_fucai3d_two_h"
                        accept=".txt" @change="chooseFile"></span> </div>
                <div class="row"> <span>50-199注</span> <span> <input type="file" data-type="3" data-fileType="pre_index_fucai3d_five_t"
                        accept=".txt" @change="chooseFile"></span> </div>
                <div class="row"> <span>1-49注</span> <span> <input type="file" data-type="4" data-fileType="pre_index_fucai3d_one"
                        accept=".txt" @change="chooseFile"></span> </div>
            </div>

            <!-- 辅助说明区：桌面端在表格右侧，移动端落到表格下方 -->
            <div class="aside">
                <span class="cttitle" @click="showImgDialog = true">系统默认天云和大赢家这样主流软件格式</span>
                <a class="cttitle ctitle2"
                    href="http://6.36886.net/stage-api/profile/upload/1/41/pre_other_file/2024/10/24/天云3D 排3_20241024141050A006.zip"
                    download>下载天云3D 排3</a>
                <span class="tish">
                    <span>发单格式:期数+用户名+注数</span>
                    <span>实例:2024115-李小龙-88.8万</span>
                    <b>温馨提示:用电信网络上传文件速度较快</b>
                </span>

            </div>
        </div>
        <div class="remark">
            <span class="remark-label">预测说明</span>
            <textarea class="remark-input" rows="10" v-model="form.preRemark"
                placeholder="温馨提示:可以介绍自己没有使用常规条件，极限条件等危险条件过滤,而是采用比较稳妥的分布过滤，冷码过滤，一级容错，二级容错，甚至三级容错技术，自我评估本期多大的单又多大的把握，提高自己的被认购率"></textarea>
        </div>

        <el-button type="primary" class="submit-btn" @click="save">确定发布</el-button>

    </div>
</template>

<script>

import Mixin from '@/views/personalCenter/sss_yuce/minix'
let mixin = new Mixin({
    lotteryType: '2',    //彩种
    lotteryName: '福彩3D',    //彩种
})

export default {
    mixins: [mixin],
    name: 'fcsd',
    data() {
        return {
            showImgDialog: false,
        }
    },
};
</script>

<style lang="scss" scoped>
@use './yuce.scss';

/* ===== 页面容器 ===== */
.fcsd-yc-page {
	max-width: 900px;
}

</style>
